import { WeekDay } from "./generic.types";

export enum AppResource {
  UNKNOWN = "UNKNOWN",
  admins = "admins",
  sportsClubs = "sportsClubs",
  clients = "clients",
  userGuide = "userGuide",
  settings = "settings",
  general = "general",
  enums = "enums",
  courts = "courts",
  courtsCategories = "courtsCategories",
  sportTypes = "sportTypes",
  courtsAvailabilitiesRanges = "courtsAvailabilitiesRanges",
  courtAvailabilities = "courtAvailabilities",
  courtsSlots = "courtsSlots",
  courtsSlotsCalendar = "courtsSlotsCalendar",
  faqs = "faqs",
  terms = "terms-and-conditions",
  termsAR = "ar/terms-and-conditions",
  termsEN = "en/terms-and-conditions",
  rooms = "rooms",
  participants = "participants",
  chat = "chat",
  roomMessages = "roomMessages",
  courtsReservations = "courtsReservations",
  sportsClubsReviews = "sportsClubsReviews",
  ads = "ads",
  brandsCategories = "brandsCategories",
  login = "login",
  products = "products",
  productsFiles = "productsFiles",
  orders = "orders",
  orderPreview = "orderPreview",
  ordersLastSeenAt = "ordersLastSeenAt",
  reservationLastSeenAt = "reservationLastSeenAt",
  clientsCarts = "clientsCarts",
  cartItems = "cartItems",
  visitsRequests = "visitsRequests",
  requestsLastSeenAt = "requestsLastSeenAt",
  agents = "agents",
  places = "places",
  brands = "brands",
  brandsDeliveryMethods = "brandsDeliveryMethods",
  brandsMedia = "brandsMedia",
  brandsFiles = "brandsFiles",
  bulkProductsCreate = "bulkProductsCreate",
  challenges = "challenges",
  gyms = "gyms",
  cancellationPolicies = "cancellationPolicies",
  paymentMethods = "paymentMethods",
  packages = "packages",
  wallets = "wallets",
  gymReviews = "gymReviews",
  adminGymReviews = "adminGymReviews",
  subscribedGyms = "subscribedGyms",
  notifications = "notifications",
  management = "management",
  profile = "profile",
  academies = "academies",
  coaches = "coaches",
  trainers = "trainers",
  subscribedAcademies = "subscribedAcademies",
  coachAvailabilities = "coachAvailabilities",
  coachAvailabilityRanges = "coachAvailabilityRanges",
  coachSlotsCalendar = "coachSlotsCalendar",
  coachSlots = "coachSlots",
  coachReservations = "coachReservations",
  academyReviews = "academyReviews",
  adminAcademyReviews = "adminAcademyReviews",
  coachReviews = "coachReviews",
  adminCoachReviews = "adminCoachReviews",
  reviews = "reviews",
  reviewsLastSeenAt = "reviewsLastSeenAt",
  entertainments = "entertainments",
  services = "services",
  adventureServices = "adventureServices",
  entertainmentServices = "entertainmentServices",
  entertainmentReviews = "entertainmentReviews",
  changedTimes = "changedTimes",
  entertainmentRequests = "entertainmentRequests",
  adventureRequests = "adventureRequests",
  sportMateEvents = "sportMateEvents",
  fcm = "fcm",

  reservations = "reservations",
  sessionsReservations = "sessionsReservations",
  storeOrders = "storeOrders",
  announcements = "announcements",
}

export interface ILocalized {
  en: string;
  ar: string;
}

export interface ILabeled {
  label: ILocalized;
}

export enum CourtsAvailabilityStatus {
  busy = "busy",
  available = "available",
  maintenance = "maintenance",
}

export enum CourtsTypes {
  coveredHall = "coveredHall",
  openHall = "openHall",
}

export interface ICourtsTypes {
  coveredHall: ILabeled;
  openHall: ILabeled;
}

export interface ICourtAvailability {
  busy: ILabeled;
  available: ILabeled;
  maintenance: ILabeled;
}

export interface IFavorites {
  consultings: ILabeled;
  events: ILabeled;
  sportsClubs: ILabeled;
  tours: ILabeled;
}

export interface ILanguages {
  en: ILabeled;
  ar: ILabeled;
}

export interface IPaymentMethods {
  card: ILabeled;
  cash: ILabeled;
}

export interface IProductsSizes {
  m: ILabeled;
}

export interface IProductsGenders {
  male: ILabeled;
}

export interface IProductsColors {
  white: ILabeled;
}

export interface ILabeledValue {
  [key: string]: ILabeled;
}

export interface ISlot {
  id: WeekDay;
  name: string;
}

export interface ISportMateType {
  [key: string]: ILabeled;
}

export interface IAreaOfAdvertising {
  [parentKey: string]: {
    categories: {
      [subCategoryKey: string]: {
        ar: string;
        en: string;
      };
    };
  };
}

export interface IEnums {
  courtsAvailabilitiesStatus: ICourtAvailability;
  courtsTypes: ICourtsTypes;
  favorites: IFavorites;
  languages: IFavorites;
  paymentMethods: IPaymentMethods;
  productsSizes: IProductsSizes;
  productsGenders: IProductsGenders;
  productsColors: IProductsColors;
  status: ILabeledValue;
  placesStatus: ILabeledValue;
  agentsStatus: ILabeledValue;
  ordersDeliveryMethods: ILabeledValue;
  cities: ILabeledValue;
  countries: ILabeledValue;
  challengeStatus: ILabeledValue;
  levelOfExperience: ILabeledValue;
  gymType: ILabeledValue;
  areaOfAdvertising: IAreaOfAdvertising;
  sportMateType: ISportMateType;
}

export enum Enums {
  courtsAvailabilitiesStatus = "courtsAvailabilitiesStatus",
  courtsTypes = "courtsTypes",
  favorites = "favorites",
  languages = "languages",
  paymentMethods = "paymentMethods",
  productsSizes = "productsSizes",
  productsGenders = "productsGenders",
  productsColors = "productsColors",
  status = "status",
  ordersDeliveryMethods = "ordersDeliveryMethods",
  cities = "cities",
  countries = "countries",
  challengeStatus = "challengeStatus",
  levelOfExperience = "levelOfExperience",
  gymType = "gymType",
  areaOfAdvertising = "areaOfAdvertising",
}

export enum ParticipantType {
  brands = "brands",
  sportsClubs = "sportsClubs",
  gyms = "gyms",
  academies = "academies",
  coaches = "coaches",
  entertainments = "entertainments",
  admin = "admins",
}

export enum ComparedDate {
  createdAt = "createdAt",
  updatedAt = "updatedAt",
}
